import { connectMediaStore } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getCustomDeviationSetStreamId } from '../helpers';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
const mapStateToProps = (state)=>{
    const streamId = getCustomDeviationSetStreamId();
    return {
        deviations: getDeviationsByIds(state, selectors.getItems(state, streamId))
    };
};
export default connectMediaStore(mapStateToProps);

//# sourceMappingURL=withCustomSetDeviations.js.map